import { CategoryCreate } from "./CategoryCreate";
import { CategoryEdit } from "./CategoryEdit";
import { CategoryList } from "./CategoryList";

export default {
  list: CategoryList,
  create: CategoryCreate,
  edit: CategoryEdit,
  recordRepresentation: "name",
};
